import React from "react";
import TradingViewWidget, { Themes } from "react-tradingview-widget";

import "./Diagram.scss";

const Diagram = ({ details, data }) => {
  return (
    <div className="row">
      {data.cc_meta_data == undefined ? (
        ""
      ) : (
        <>
          <div className="diagramName col-12" style={{ fontWeight: "bold" }}>
            <span style={{ borderBottom: "2px solid #4e0f8c" }}>
              نمودار تحلیل تکنیکال
            </span>
            <span> {data.cc_meta_data.farsi_name}</span>
          </div>
          <div className="col-12 diagram">
            <TradingViewWidget
              symbol={details.nameChart}
              theme={Themes.light}
              locale="fa_IR"
              autosize
              timezone="Asia/Tehran"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Diagram;
